import React, { Component } from "react";
import _ from "lodash";

import TodoWatch from "./TodoWatch";
import Summary from "./Summary";

export default class Quiz4Feedback extends Component {
  render() {
    return (
      <div>
        <TodoWatch />
        <Summary />
      </div>
    );
  }
}
